import { parseISO } from 'date-fns';

import type { HybrisTimeWindow, HybrisTimeWindowList } from '../../models/hybris/hybrisTimeWindow';
import type { ApiTimeslot, TimeslotType } from './timeslotModels';

export const mapTimeslot = (
    hybrisTimeslot: HybrisTimeWindow, // it needs to have an id to be proper timeslot
): ApiTimeslot | null => {
    if (!hybrisTimeslot.id) {
        return null;
    }

    return {
        cost: hybrisTimeslot.cost,
        netCost: hybrisTimeslot.netCost,
        expirationTime: hybrisTimeslot.expirationTime
            ? parseISO(hybrisTimeslot.expirationTime).valueOf()
            : undefined,
        id: hybrisTimeslot.id,
        timeSlotDay: hybrisTimeslot.timeSlotDay,
        timeSlotTime: hybrisTimeslot.timeSlotTime,
        fullyBooked: hybrisTimeslot.fullyBooked || false,
        startTime: parseISO(hybrisTimeslot.startTime).valueOf(),
        endTime: parseISO(hybrisTimeslot.endTime).valueOf(),
        maxOrderTime: parseISO(hybrisTimeslot.stopTime).valueOf(),
        storeId: hybrisTimeslot.storeCode,
        timeslotType: mapTimeslotType(hybrisTimeslot.timeWindowType),
        ecoFriendly: hybrisTimeslot.ecoFriendly || false,
        isMemberPrice: hybrisTimeslot.isMembership || false,
        expectETANotification: hybrisTimeslot.expectETANotification,
    };
};

export const mapTimeslotList = (hApiResponse: HybrisTimeWindowList) => {
    return hApiResponse.listOfTimeWindowListWsDTO.reduce<ApiTimeslot[]>((acc, curr) => {
        const mapped = curr.timeWindowListWsDTO.map(mapTimeslot).filter(Boolean);
        return [...acc, ...mapped];
    }, []);
};

const mapTimeslotType = (hybrisTimeslotType?: string): TimeslotType => {
    if (!hybrisTimeslotType) {
        return undefined;
    }

    switch (hybrisTimeslotType) {
        case 'EXPRESS':
        case 'SAME_DAY':
            return hybrisTimeslotType;
        default:
            return 'REGULAR';
    }
};
